import axios from "axios";
import VueAxios from "vue-axios";
import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index";
Vue.use(VueAxios, axios);
Vue.use(Vuex);

import { EncryptStorage } from "encrypt-storage";
export const encryptStorage = new EncryptStorage("secret-key-value", {
  prefix: "@effo",
  encAlgorithm: "Rabbit",
});
export default new Vuex.Store({
  state: {
    connection_snack: false,
    drawer: true,
    mini: false,
     def_path: "https://main.effo.app",
    //def_path: "http://127.0.0.1:8000",
    token: encryptStorage.getItem("token_ergu_user") || null,
    ergu_user: encryptStorage.getItem("effo_user") || {
      permissions: [],
      assoication_permissions: [],
    },

    break_point: 0,
  },
  getters: {
    loggedin(state) {
      return state.token != null;
    },
    permission: (state) => (permission) => {
      return state.ergu_user.permissions.includes(permission);
    },
    assoication_permissions(state) {
      return state.ergu_user.assoication_permissions;
    },
    first_route(state) {
      let final_per = state.ergu_user.permissions.filter((pre) =>
        pre.includes("access")
      );
      if (final_per.length != 0) {
        if (final_per.includes("products access")) {
          return "products";
        } else {
          return final_per[0].split(" ")[0];
        }
      }

      return "problem";
    },
  },
  mutations: {
    login(state, token) {
      state.token = token;
    },
    logout(state) {
      state.token = null;
      encryptStorage.removeItem("token_ergu_user");
      encryptStorage.removeItem("effo_user");
    },
    user(state, user) {
      state.ergu_user = user;
    },
  },
  actions: {
    login(context, cred) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("phone_number", cred.phone_number);
        formData.append("password", cred.password);
        var config = {
          method: "post",
          url: "login",
          headers: {
            Accept: "application/json",
          },
          data: formData,
        };
        axios(config)
          .then((res) => {
            const token = res.data.data.token;
            encryptStorage.setItem("token_ergu_user", token);
            encryptStorage.setItem("effo_user", res.data.data);
            context.commit("login", token);
            context.commit("user", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // public request this function handel any requset type like post & get Etc ...
    public__request(context, cred) {
      return new Promise((resolve, reject) => {
        let config = {
          method: cred.config.method,
          url: cred.config.url,
          headers: {
            Accept: "application/json",
            "Content-Type": cred.config.type
              ? cred.config.type
              : "application/json",
            Authorization: `Bearer ${context.state.token}`,
          },
          data: cred.data || [],
        };
        axios(config)
          .then((res) => {
            resolve(res);
            context.state.connection_snack = false;
            if (cred.get) {
              context.commit("public__request", {
                data: res.data,
                name: cred.get,
              });
            }
          })
          .catch((err) => {
            if (!err.response) {
              context.state.connection_snack = true;
            } else {
              reject(err);
            }
            if (err.response.status == 401) {
              context.commit("logout");
              router.push("/");
            }
          });
      });
    },
  },
  modules: {},
});
